import React from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import './home.css'

const Home: React.FC = () => {
  return (
    <div className="home-container1">
      <Helmet>
        <title>ProyectoGanando</title>
        <meta property="og:title" content="ProyectoGanando" />
      </Helmet>
      <div className="home-container2">
        <Link to="/login" className="home-navlink button hover-effect-logo">
        </Link>
        <a
          href="https://forjadecodigo.com"
          target="_blank"
          rel="noreferrer noopener"
          className="home-link Botones button hover-effect-logo"
        >
        </a>
      </div>
    </div>
  )
}

export default Home

